define(["require", "exports"], function (require, exports) {
    "use strict";
    exports.__esModule = true;
    function default_1(func, wait) {
        return setTimeout(func, wait);
    }
    exports["default"] = default_1;
});



//////////////////
// WEBPACK FOOTER
// ./Scripts/built/defer.js
// module id = 35
// module chunks = 0